export class SourceAccountTagKeysCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "sourceAccountTagKeys",
            "baseName": "sourceAccountTagKeys",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountTagKeysCondition.attributeTypeMap;
    }
    constructor() {
    }
}
